/**
 * Enumerations shared by API, database and UI. They mirror the Prisma enums 1:1
 * (the API has a compile-time check that keeps them in sync).
 */

export const USER_STATUSES = ['ACTIVE', 'DEACTIVATED', 'PENDING_DELETION', 'DELETED'] as const;
export type UserStatus = (typeof USER_STATUSES)[number];

export const PRODUCT_STATUSES = ['DRAFT', 'PUBLISHED', 'ARCHIVED'] as const;
export type ProductStatus = (typeof PRODUCT_STATUSES)[number];

export const AVAILABILITIES = ['IN_STOCK', 'LOW_STOCK', 'MADE_TO_ORDER', 'OUT_OF_STOCK'] as const;
export type Availability = (typeof AVAILABILITIES)[number];

export const PRICE_UNITS = ['PER_SQ_FT', 'PER_SLAB', 'ON_REQUEST'] as const;
export type PriceUnit = (typeof PRICE_UNITS)[number];

export const QUANTITY_UNITS = ['SQ_FT', 'SLAB'] as const;
export type QuantityUnit = (typeof QUANTITY_UNITS)[number];

export const DISCOUNT_TYPES = ['PERCENTAGE', 'FLAT'] as const;
export type DiscountType = (typeof DISCOUNT_TYPES)[number];

export const IMAGE_KINDS = ['GALLERY', 'MACRO', 'TEXTURE', 'SCENE'] as const;
export type ImageKind = (typeof IMAGE_KINDS)[number];

export const ENQUIRY_TYPES = ['RESIDENTIAL', 'COMMERCIAL', 'DEALER', 'OTHER'] as const;
export type EnquiryType = (typeof ENQUIRY_TYPES)[number];

export const ENQUIRY_SOURCES = ['CONTACT_FORM', 'PRODUCT_PAGE'] as const;
export type EnquirySource = (typeof ENQUIRY_SOURCES)[number];

export const ENQUIRY_STATUSES = [
  'NEW',
  'IN_PROGRESS',
  'QUOTED',
  'ACCEPTED',
  'REJECTED',
  'CANCELLED',
  'CLOSED',
] as const;
export type EnquiryStatus = (typeof ENQUIRY_STATUSES)[number];

export const ACTOR_TYPES = ['CUSTOMER', 'ADMIN', 'SYSTEM'] as const;
export type ActorType = (typeof ACTOR_TYPES)[number];

export const EMAIL_TOKEN_TYPES = [
  'VERIFY_EMAIL',
  'RESET_PASSWORD',
  'CHANGE_EMAIL',
  'DELETE_ACCOUNT_OTP',
  'CANCEL_DELETION',
  'ENQUIRY_CONFIRM',
  'NEWSLETTER_CONFIRM',
] as const;
export type EmailTokenType = (typeof EMAIL_TOKEN_TYPES)[number];

export const IDENTITY_PROVIDERS = ['GOOGLE'] as const;
export type IdentityProvider = (typeof IDENTITY_PROVIDERS)[number];
